import { formatPrice } from '../../lib/format'

/**
 * Unsigned money balance for wallet/pool headlines. formatPrice renders 0¢ as
 * "Free" (store-price semantics) — a balance must read as an honest $0.00.
 */
export function formatBalance(cents: number, currency: string): string {
  if (cents !== 0) return formatPrice({ cents, currency })
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency || 'USD',
    }).format(0)
  } catch {
    return `${currency || 'USD'} 0.00`
  }
}

/** "12.50" / "$12.50" / "12" → integer cents; null when not a plain dollar amount. */
export function parseDollarsToCents(text: string): number | null {
  const cleaned = text.trim().replace(/^\$/, '')
  if (!/^\d+(\.\d{1,2})?$/.test(cleaned)) return null
  return Math.round(Number(cleaned) * 100)
}
